__turbopack_context__.v({
  "addressText": "DiDGUq_addressText",
  "available": "DiDGUq_available",
  "container": "DiDGUq_container",
  "cuisineText": "DiDGUq_cuisineText",
  "footer": "DiDGUq_footer",
  "footerLeft": "DiDGUq_footerLeft",
  "orderFormat": "DiDGUq_orderFormat",
  "whiteLabeled": "DiDGUq_whiteLabeled",
});
